import {
    CommandResponse,
    EntityCommandCreateResponse,
    RevisionedCommandResponse,
    StudyEntityType,
    VeevaCaseReportFormMapping,
} from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';

const factory = createStudyEntityHookFactory<VeevaCaseReportFormMapping>(StudyEntityType.VeevaFormMapping);

export const useVeevaCaseReportFormMappingInsert = factory.mutate(
    (entity: VeevaCaseReportFormMapping): Promise<RevisionedCommandResponse<EntityCommandCreateResponse>> => {
        return axios
            .post(`/api/study-designer/studies/${entity.studyId}/veeva-case-report-form-mapping`, entity)
            .then(response => response.data);
    }
);
export const useVeevaCaseReportFormMappingUpdate = factory.mutate(
    (entity: VeevaCaseReportFormMapping): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .put(`/api/study-designer/studies/${entity.studyId}/veeva-case-report-form-mapping/${entity.id}`, entity)
            .then(response => response.data);
    }
);

export const useVeevaCaseReportFormMappingDelete = factory.mutate(
    (entity: VeevaCaseReportFormMapping): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .delete(`/api/study-designer/studies/${entity.studyId}/veeva-case-report-form-mapping/${entity.id}`)
            .then(response => response.data);
    }
);

export const useVeevaCaseReportFormMappingBatchDelete = factory.mutate(
    (params: { studyId: string; mappingIds: string[] }): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .post(`/api/study-designer/studies/${params.studyId}/veeva-case-report-form-mapping/actions/delete-batch`, {
                mappingIds: params.mappingIds,
            })
            .then(response => response.data);
    }
);

export const useVeevaCaseReportFormMappingSyncWithSoA = factory.mutate(
    (params: { studyId: string }): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .post(
                `/api/study-designer/studies/${params.studyId}/veeva-case-report-form-mapping/actions/sync-with-schedule-of-activities`,
                {}
            )
            .then(response => response.data);
    }
);
